<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import { countToShow } from "%/dynamic-component-editor/helpers/story-engagement.mjs";
import ButtonActionCountOptions from "%/dynamic-component-editor/bundles/button-action-count-options";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";

export default {
  name: "CommentCount",
  elementPanelSettings: {
    displayName: "Comment Count",
    displayIcon: "material-symbols:filter-1-outline",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: ActionCountElement,
  mixins: [StoryPageElementMixin],
  optionBundles: [
    new ButtonActionCountOptions({ "default.icon": ENGAGEMENT_ICONS.comment, "default.display-icon": "hide" }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canCommentOnPosts",
    ]),
    shouldShowAction() {
      return this.editMode || this.canCommentOnPosts;
    },
    myValue() {
      return countToShow(this.entity.commentCount, this.getOptionValue(DisplayValue));
    },
  },
  methods: {
    handleClick() {
      window.location.href = `${this.links.web}/story/${this.entity.storyId}`;
    },
  },
};
</script>
